import { Component, OnInit, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { TeamDetailsService } from '../team-details.service';
import { images } from '../../../../app/_shared/data/image';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { DisplayValuePipe } from './display-email-phone';

@Component({
  selector: 'app-team-fans',
  templateUrl: './team-fans.component.html',
  styleUrls: ['./team-fans.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    EmptyPageModule,
    DisplayValuePipe
  ]
})
export class TeamFansComponent implements OnInit, OnDestroy {
  isLoading = true;
  private readonly destroy$ = new Subject<void>();
  teamId: string;
  followers: any[] = []; // ideally create Fan model
  avatarImage = images.avatarImage;

  constructor(
    private teamDetailsService: TeamDetailsService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getRouteSubscription();
  }

  getFollowers() {
    if (!this.teamId) return;

    this.isLoading = true;

    this.teamDetailsService
      .getFollowers(this.teamId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.followers = res.data || [];
          this.isLoading = false;
        },
        error: (err) => {
          console.error(err);
          this.isLoading = false;
        },
      });
  }



  getRouteSubscription() {
    this.activatedRoute.parent?.params
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (params) => {
          this.teamId = params['id'];
          this.getFollowers(); // fetch after getting id
        },
        error: (err) => {
          console.error('Route subscription error:', err);
        },
      });

    this.teamDetailsService.subscribeUpdateFans()
      .pipe(takeUntil(this.destroy$))
      .subscribe((update) => {
        if (update) {
          this.getFollowers();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}